import React from 'react'

import useStyles from './styles/verticalSeparator.style'

const VerticalSeparator = () => {
  const classes = useStyles()
  return <div className={classes.root} />
}

export default VerticalSeparator
